import { bearerFetcher } from "matsuri-hooks"
import { m2mCleaning_cleanerV3 } from "../endpoints/m2m-cleaning.cleaner-v3"
import { ShiftStatus } from "@/model/shift"

export const requestCreateShift = (
    token: string,
    input: {
        start: number
        end: number
    }
) => {
    const endpoint = m2mCleaning_cleanerV3.createShift

    return bearerFetcher(token, endpoint(), {
        method: endpoint.method,
        body: JSON.stringify(input)
    })
}

export const requestUpdateShift = (
    token: string,
    shiftId: string,
    input: {
        start: number
        end: number
        status: ShiftStatus
    }
) => {
    const endpoint = m2mCleaning_cleanerV3.updateShift

    return bearerFetcher(token, endpoint({ shiftId }), {
        method: endpoint.method,
        body: JSON.stringify(input)
    })
}

export const requestSubmitShifts = (
    token: string,
    input: { shiftIds: string[] }
) => {
    const endpoint = m2mCleaning_cleanerV3.submitShift

    return bearerFetcher(token, endpoint(), {
        method: endpoint.method,
        body: JSON.stringify(input)
    })
}

export const requestDeleteShift = (token: string, shiftId: string) => {
    const endpoint = m2mCleaning_cleanerV3.deleteShift

    return bearerFetcher(token, endpoint({ shiftId }), {
        method: endpoint.method
    })
}

export const requestUnsubmitShift = (token: string, shiftId: string) => {
    const endpoint = m2mCleaning_cleanerV3.unsubmitShift

    return bearerFetcher(token, endpoint({ shiftId }), {
        method: endpoint.method
    })
}
